export enum PopUpConfirmInputType {
  Text = "text",
  Number = "number",
}

export interface PopUpConfirmResult {
  input: string | null;
  dropdown: string | null;
}
